interface Props {
  url: string;
  alt?: string;
}

export function ImageBlock({ url, alt }: Props) {
  return (
    <div className="my-2">
      <img
        src={url}
        alt={alt ?? ""}
        className="max-w-full max-h-[400px] rounded-md border border-white/[0.06] object-contain"
        loading="lazy"
      />
      {alt && <span className="text-[10px] text-zinc-500 mt-1 block">{alt}</span>}
    </div>
  );
}
